import React from "react";

const Banniere = () => {
  return (
    <div className="banniere">
      <img src="/assets/LOGOASBIEN.png" alt="logoAS" height="200" width="140" />
    </div>
  );
};

export default Banniere;
